import { PopoverTrigger } from "@/components/ui/popover";
import { CirclePlusIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export function TableFilterButton({
  label,
  numSelected,
  onClear,
  selectedLabel,
}: {
  numSelected: number;
  label: ReactNode;
  selectedLabel: ReactNode;
  onClear: () => void;
}) {
  return (
    <PopoverTrigger className="leading-2 flex items-center space-x-1 rounded-full border border-dashed border-gray-300 px-2 py-0.5 text-xs transition-all hover:border-gray-500 hover:bg-gray-100">
      <CirclePlusIcon
        onClick={(e) => {
          if (numSelected === 0) return;

          e.preventDefault();

          onClear();
        }}
        className={cn("h-3 w-3 flex-shrink-0 transition-all", {
          "rotate-0": numSelected === 0,
          "rotate-45 hover:text-red-500": numSelected > 0,
        })}
      />
      <span className="font-semibold text-gray-700">{label}</span>

      {numSelected > 0 && (
        <span className="border-l border-gray-300 px-1 font-semibold text-indigo-500">
          {selectedLabel}
        </span>
      )}
    </PopoverTrigger>
  );
}
